import './styles/app.css';
import './styles/stage.css';
import { createApp, type App } from './app.js';

/**
 * Entry point shared by every generated page.
 *
 * The same bundle serves the SPA (`/validator`) and the per-document SEO pages,
 * which provide the H1 and the crawlable text; here we only mount the widget and
 * pick the initial document from the markup or from the URL.
 */

const mountElement = document.getElementById('app');
let app: App | null = null;

const documentIdFromLocation = (): string | undefined => {
  const match = /\/validator\/([a-z0-9-]+)/i.exec(window.location.pathname);
  return match?.[1];
};

if (mountElement) {
  const params = new URLSearchParams(window.location.search);
  const debug = params.get('debug') === '1' || params.get('debug') === 'true';
  const inline = mountElement.dataset['mount'] === 'inline';
  const fromMarkup = mountElement.dataset['document'];

  app = createApp({
    mount: mountElement,
    ...(fromMarkup ?? documentIdFromLocation()
      ? { initialDocumentId: fromMarkup ?? (documentIdFromLocation() as string) }
      : {}),
    inline,
    debug,
  });

  window.addEventListener('beforeunload', () => app?.destroy());
  window.addEventListener('pagehide', () => app?.destroy());
}

export {};
